import { useEffect, useState } from "react";
import axios from "axios";
import { appConstants } from "../_constants/app.constants";
import { useAuth } from "../auth/AuthContext";

/**
 * Fetches current user's tournament permissions for conditional empty states / CTAs.
 * When not logged in, returns canManage: false without calling the API.
 */
export function useTournamentAccess(tournamentId) {
  const { user } = useAuth();
  const [state, setState] = useState({ canManage: false, loaded: false });

  useEffect(() => {
    if (!tournamentId) {
      setState({ canManage: false, loaded: true });
      return undefined;
    }
    if (!user) {
      setState({ canManage: false, loaded: true });
      return undefined;
    }

    let cancelled = false;
    axios
      .get(`${appConstants.API_URL}/api/tournaments/${tournamentId}/access`)
      .then((res) => {
        if (!cancelled) setState({ canManage: Boolean(res.data?.canManage), loaded: true });
      })
      .catch(() => {
        if (!cancelled) setState({ canManage: false, loaded: true });
      });

    return () => {
      cancelled = true;
    };
  }, [user, tournamentId]);

  return state;
}
